/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpRequestConfig } from './HttpClient';

export abstract class HttpClientDecorator implements HttpClient {
  constructor(protected readonly httpClient: HttpClient) {}

  onUnauthorized(listener: (reason: unknown) => void): void {
    return this.httpClient.onUnauthorized(listener);
  }

  get<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.get<ResponseData, ResponseMeta>(url, config);
  }

  post<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.post<ResponseData, ResponseMeta>(url, config);
  }

  put<ResponseData = any, ResponseMeta = any>(
    url: string,
    config?: HttpRequestConfig,
  ): Promise<{ data: ResponseData; meta: ResponseMeta; success: boolean }> {
    return this.httpClient.put<ResponseData, ResponseMeta>(url, config);
  }
}
